module.exports = __webpack_public_path__ + "489e619264d64d3190bdeb62f148c311.png";